import * as React from 'react'
import _ from 'underscore'
import Percent from '../helper/percent'
import { XhprofNamespace } from '../xhprof/XhprofReportGenerator'

interface Props {
    namespaces: XhprofNamespace[]
    filter: any
    onClick: (namespace: string) => void
    totalWalltime: number
}

interface State {
    showAll: boolean
}

class NamespaceSelector extends React.Component<Props, State> {
    public state: State = {
        showAll: false,
    }

    public render = () => {
        const { showAll } = this.state

        const namespaces = showAll ? this.props.namespaces : this.props.namespaces.slice(0, 5)

        return (
            <div className="row" style={{ marginTop: 8 }}>
                <div className="col-md-12">
                    <ul className="list-unstyled list-inline tw-line-height-40 " style={{ marginLeft: 0, paddingLeft: 0 }}>
                        {namespaces.map(namespaceStats => {
                            const namespace = Object.keys(namespaceStats)[0]

                            return (
                                <li key={namespace} className={_.contains(this.props.filter, namespace) ? 'active' : ''}>
                                    <a className={this.getClasses(namespace)} onClick={() => this.props.onClick(namespace)}>
                                        {namespace} <Percent value={namespaceStats[namespace].excl_wt / this.props.totalWalltime} />
                                    </a>
                                </li>
                            )
                        })}
                        <li>
                            <a className="tw-font-weight-normal" onClick={() => this.setState({ showAll: !showAll })}>
                                {showAll ? 'show less' : 'show all'}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }

    private getClasses = (namespace: string): string => {
        const classes = ['label', 'tw-font-weight-normal']

        if (_.contains(this.props.filter, namespace)) {
            classes.push('tw-color-grey-50')
            classes.push('tw-bg-grey-400')
        } else {
            classes.push('tw-color-grey-500')
            classes.push('tw-bg-grey-50')
        }

        return classes.join(' ')
    }
}

export default NamespaceSelector
